interface IconProps {
  color?: string
  className?: string
}

export default function TwitterIcon({ color: _color, className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M136.533333 0h750.933334c75.093333 0 136.533333 61.44 136.533333 136.533333v750.933334c0 75.093333-61.44 136.533333-136.533333 136.533333H136.533333c-75.093333 0-136.533333-61.44-136.533333-136.533333V136.533333c0-75.093333 61.44-136.533333 136.533333-136.533333z"
        fill="#3298F0"
      />
      <path
        d="M747.52 402.773333v-17.066666c23.893333-17.066667 44.373333-40.96 61.44-64.853334-20.48 10.24-44.373333 17.066667-68.266667 20.48 23.893333-13.653333 44.373333-40.96 54.613334-68.266666-23.893333 13.653333-47.786667 23.893333-75.093334 30.72-20.48-23.893333-54.613333-40.96-88.746666-40.96-68.266667 0-119.466667 54.613333-119.466667 126.293333 0 10.24 0 20.48 3.413333 30.72-98.986667-6.826667-187.733333-58.026667-249.173333-136.533333-17.066667 13.653333-23.893333 34.133333-23.893333 58.026666 0 44.373333 20.48 85.333333 54.613333 109.226667-20.48 0-37.546667-6.826667-54.613333-17.066667 0 61.44 40.96 116.053333 95.573333 126.293334-10.24 3.413333-20.48 3.413333-30.72 3.413333-6.826667 0-13.653333 0-23.893333-3.413333 13.653333 51.2 61.44 88.746667 112.64 88.746666-40.96 34.133333-92.16 54.613333-150.186667 54.613334-10.24 0-20.48 0-27.306667-3.413334 54.613333 37.546667 116.053333 58.026667 184.32 58.026667 221.866667 6.826667 344.746667-187.733333 344.746667-354.986667z"
        fill="#FFFFFF"
      />
    </svg>
  )
}
